import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";
import { useForm } from "react-hook-form";
import {
  ButtonField,
  Iconsvg,
  Notification
} from "@wk/components-react16";
import { captcha, SITE_KEY } from "constants/config";
import loadGoogleCaptcha from "helpers/googleRecaptchaLoader";
import { getContactForm } from "services/csa-api/csaThunk";
import { csaSelector } from "services/csa-api/csaSlice";
import Fields from "./Fields";
import {sendContactFormData} from "../../../services/salesforce/salesforceThunk";

export const ContactSelection = ({ cid, tid, messageSent }) => {
  const dispatch = useDispatch();
  const formManager = useForm({
    defaultValues: {
      company: "",
      email: "",
      name: "",
      phone: "",
      subject: "",
      tempAbonummer: "",
      tempDatenschutzhinweise: false,
      tempDescription: "",
      tempKuendigungsgrund: "",
      tempKundennummer: "",
      tempRechnungsnummer: "",
      tempStadt: "",
      tempStrasse: "",
      tempPLZ: "",
      tempUsername: "",
    },
    mode: "onTouched",
  });
  const { getValues, handleSubmit, clearErrors, setError } = formManager;
  const { formInputs } = useSelector(csaSelector);
  const [formFields, setFormFields] = useState(null);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [errorNotification, showErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const product = sessionStorage.getItem("contact_product") || "default";
    dispatch(getContactForm({cid, tid, product})).then(res => {
      setFormFields(res.payload.fields);
      setTimeout(() => {
        setIsLoading(false);
      }, 750);
    });
    loadGoogleCaptcha.loadCaptchaBadge(
      "recaptcha-key",
      `${captcha}?render=${SITE_KEY}&badge=bottomleft`,
      function () {}
    );
    loadGoogleCaptcha.toggleCaptchaBadge(true);
    return () => loadGoogleCaptcha.toggleCaptchaBadge(false);
  }, []);

  const onSubmit = () => {
    // get the token from google captcha by passing SITE_KEY and action
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: "submit" })
        .then((token) => {
          submitData(token);
        });
    });
  };

  const submitData = async (token) => {
    try {
      setIsLoading(true);
      showErrorNotification(false);
      setErrorMessage("");
      clearErrors();

      const userData = {
        request_token: token,
      };

      // dynamically add fields for current form
      formInputs.fields.forEach(input => {
        userData[input.name] = getValues(input.name);
      });
      userData["category"] = document.querySelector("#form-select-category").value;
      userData["topic"] = document.querySelector("#form-select-topic").value;
      userData["product"] = sessionStorage.getItem("contact_product") || "default";
      if (sessionStorage.getItem("wkn")) {
        userData["wkn"] = sessionStorage.getItem("wkn");
      }

      dispatch(sendContactFormData(userData)).then(async (res) => {
        if (res.payload.success) {
          messageSent();
        } else {
          setErrorMessage("[500] Ihre Daten konnten nicht an unser System übertragen werden.");
          showErrorNotification(true);
          setIsLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
      showErrorNotification(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    const product = sessionStorage.getItem("contact_product") || "default";
    dispatch(getContactForm({cid, tid, product})).then(res => {
      setFormFields(res.payload.fields);
      setTimeout(() => {
        setIsLoading(false);
      }, 750);
    });
  }, [cid, tid]);

  return (
    <>
      { isLoading ? (
        <div className="form-selection-loading wk-align-center">
          <Iconsvg name="spinner" isSpin size={32} />
        </div>
      ) : (
        <>
          { formInputs.helper &&
            <div className="wk-contact-tipp">
              <div className="wk-contact-tipp-icon-wrapper">
                <Iconsvg name="lightbulb" size="32"/>
              </div>
              <div className="wk-contact-tipp-content-wrapper">
                <span className="wk-contact-tipp-header">Tipp</span>
                <div className="wk-contact-tipp-content">
                  {parse(formInputs.helper)}
                </div>
              </div>
            </div>
          }
          <div className="wk-contact-form-header">
            <p>Nutzen Sie das Kontaktformular und teilen Sie uns Ihr Anliegen mit. Unser Kundenservice wird sich schnellstmöglich bei Ihnen melden.</p>
          </div>
          <form className="wk-form wk-contact-form" id="wk-form-contact-request" onSubmit={handleSubmit(onSubmit)}>
            {errorNotification && (
              <Notification
                type="error"
                heading="Registrierung nicht erfolgreich"
                hasCloseButton={false}
              >
                <span slot="notificationContent">
                  { errorMessage !== ""
                    ? errorMessage
                    : "Bitte überprüfen Sie Ihre Eingaben und füllen Sie alle Pflichtfelder aus."
                  }
                </span>
              </Notification>
            )}
            {formFields && (
              <fieldset className="wk-technical-fieldset">
                <p className="required-indicator">Erforderliche Angaben sind mit <span className="required-indicator-asterisk">*</span> markiert.</p>
                <Fields
                  formManager={formManager}
                  inputs={formFields}
                  submitDisabled={submitDisabled}
                  setSubmitDisabled={setSubmitDisabled}
                  setErrorNotification={showErrorNotification}
                />
              </fieldset>
            )}
            <ButtonField>
              <button
                type="submit"
                disabled={submitDisabled}
              >
                Senden
              </button>
            </ButtonField>
          </form>
        </>
        )}
    </>
  );
}

export default ContactSelection;
